import { CountryCode } from '@/graphql/api'
import type { Locale } from '@/i18n'

export function getLocaleByCountry(
    countryCode: CountryCode | undefined
): Locale {
    if (countryCode === CountryCode.Us) {
        return 'en-us'
    } else {
        return 'en-gb'
    }
}
